import { Path } from '@/main/router/routerPath';

import { Provozovna } from './provozovna';
import { CdbLog } from './cdbLog';
import { Pages } from './pages';
import { SidloFirmy } from './sidloFirmy';
import { UzivatelskyProfil } from './uzivatelskyProfil';
import OAplikaci from './OAplikaci.vue';
import { Organizace } from './organizace';
import { ProvozovnaServisniPersonal } from './provozovna/servisniPersonal';
import { MobilniZarizeni } from './mobilniZarizeni';
import { PovinnaPole } from './povinnaPole';
import { ElektronickaFakturace } from './elektronickaFakturace';
import { LogSystemUdalosti } from './logSysUdalosti';
import { HaleroveVyrovnani } from './haleroveVyrovnani';
import { LimityCiselnychRad } from './limityCiselnychRad';
import { NastaveniExportu } from './nastaveniExportu';
import { NastaveniUpozornovani } from './nastaveniUpozornovani';
import { ZmenaHesla } from './zmenaHesla';
import { NastaveniTisku } from './nastaveniTisku';
import { WatchlistApproval } from './watchlistApproval';
import { OrganizacniJednotky } from './organizacniJednotky';
import { Pracovnik } from './pracovnik';
import { NewCdbLog } from './newCdbLog';

export const router = new Path('Administrace').addChildren([
	Pages.router,
	Provozovna.router,
	CdbLog.router,
	NewCdbLog.router,
	SidloFirmy.router,
	UzivatelskyProfil.router,
	Organizace.router,
	MobilniZarizeni.router,
	ProvozovnaServisniPersonal.router,
	PovinnaPole.router,
	ElektronickaFakturace.router,
	LogSystemUdalosti.router,
	HaleroveVyrovnani.router,
	LimityCiselnychRad.router,
	NastaveniExportu.router,
	NastaveniUpozornovani.router,
	ZmenaHesla.router,
	NastaveniTisku.router,
	WatchlistApproval.router,
	OrganizacniJednotky.router,
	Pracovnik.router,

	new Path('OAplikaci', OAplikaci, 'OAplikaci'),
]);
